import pluginMold from './index.vue';

pluginMold.install = (vue) => {
  vue.component(pluginMold.name, pluginMold);
};

export default pluginMold;
